import * as React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

export interface CheckboxFieldProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: React.ReactNode;
  description?: string;
  id?: string;
  disabled?: boolean;
  className?: string;
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({
  checked,
  onChange,
  label,
  description,
  id,
  disabled,
  className,
}) => {
  const generatedId = React.useId();
  const controlId = id ?? generatedId;
  const descriptionId = description ? `${controlId}-description` : undefined;

  return (
    <div className={cn('flex items-start gap-2.5', className)}>
      <Checkbox
        id={controlId}
        checked={checked}
        disabled={disabled}
        aria-describedby={descriptionId}
        // Radix emits boolean | 'indeterminate'; this control is binary.
        onCheckedChange={(next) => onChange(next === true)}
        className="mt-0.5"
      />
      <div className="flex min-w-0 flex-col gap-0.5">
        <Label
          htmlFor={controlId}
          className={cn(
            'revy-cjk text-sm font-normal leading-[1.5]',
            disabled ? 'cursor-not-allowed opacity-70' : 'cursor-pointer',
          )}
        >
          {label}
        </Label>
        {description && (
          <p
            id={descriptionId}
            className="revy-cjk max-w-[40em] text-xs leading-[1.7] tracking-[0.02em] text-muted-foreground"
          >
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export { CheckboxField };
